import { ResponseType } from "@sphtech/web2-core/ssr";

import LegacyPage from "../pages/LandingPage/LegacyPage";
import { landingMeta } from "../pages/LandingPage/meta";

// The A/B control: the 1.0 page, on the URL it has always had.
export function meta() {
  return landingMeta("en", "control");
}

export function loader() {
  return {
    type: ResponseType.SUCCESS,
    statusCode: 200 as const,
    payload: {},
    lang: "en",
  };
}

export default function IndexRoute() {
  return <LegacyPage lang="en" />;
}
